import { useTranslation } from '@thoughtspot/i18n';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { Radio } from '@thoughtspot/radiant-react/widgets/radio';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import React, { useCallback, useEffect, useRef, useState, } from 'react';
import { FeatureManagementTranslationKeys } from '../../constants';
import styles from './preserve-override-modal.module.scss';
export var OverrideOption;
(function (OverrideOption) {
    OverrideOption["PRESERVE"] = "preserve";
    OverrideOption["IGNORE"] = "ignore";
})(OverrideOption || (OverrideOption = {}));
export const PreserveOverrideModal = ({ isOpen, configName, configLabel, onDismiss, onUpdate, }) => {
    const { t } = useTranslation();
    const configNameRef = useRef(configName);
    useEffect(() => {
        if (configName) {
            configNameRef.current = configName;
        }
    }, [configName]);
    const [selectedOption, setSelectedOption] = useState(OverrideOption.PRESERVE);
    useEffect(() => {
        if (isOpen) {
            setSelectedOption(OverrideOption.PRESERVE);
        }
    }, [isOpen]);
    const handleChange = (event) => {
        const target = event.target;
        setSelectedOption(target.value);
    };
    const handleUpdate = useCallback(() => {
        onUpdate(selectedOption);
    }, [selectedOption, onUpdate]);
    return (React.createElement(Modal, { isOpen: isOpen, onDismiss: onDismiss, size: ModalSize.XSMALL, title: t(FeatureManagementTranslationKeys.PRESERVE_OVERRIDE_MODAL_TITLE, {
            configName: configLabel || configName || configNameRef.current,
        }), dismissButton: {
            text: t('CANCEL'),
            onClick: onDismiss,
        }, confirmButton: {
            text: t(FeatureManagementTranslationKeys.PRESERVE_OVERRIDE_MODAL_UPDATE),
            onConfirm: handleUpdate,
        }, modalTestId: "preserve-override-modal" },
        React.createElement(Vertical, { spacing: "e" },
            React.createElement(Typography, { variant: "body-normal", className: styles.questionLabel }, t(FeatureManagementTranslationKeys.PRESERVE_OVERRIDE_MODAL_QUESTION)),
            React.createElement(Radio.Group, { selectedValue: selectedOption, onChange: handleChange, orientation: "list", legendContent: t(FeatureManagementTranslationKeys.PRESERVE_OVERRIDE_MODAL_QUESTION) },
                React.createElement(Radio, { label: t(FeatureManagementTranslationKeys.PRESERVE_OVERRIDE_MODAL_PRESERVE_LABEL), value: OverrideOption.PRESERVE, isSideLabel: true }),
                React.createElement(Radio, { label: t(FeatureManagementTranslationKeys.PRESERVE_OVERRIDE_MODAL_IGNORE_LABEL), value: OverrideOption.IGNORE, isSideLabel: true })))));
};
//# sourceMappingURL=preserve-override-modal.js.map